import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { resetPassword } from '../api/authService';
import companyLogo from '../assets/company-logo.svg';

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!form.password) {
      setError('Password is required');
      return;
    }
    
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await resetPassword(token, form.password);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Failed to reset password. The link may be invalid or expired.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (success) {
    return (
      <div className="container-auth">
        <div className="box-auth">
          <div className="logo-wrapper">
            <img src={companyLogo} alt="Redwood Midcap" className="logo" />
          </div>
          <div className="form-header-auth">
            <h2>Password Reset Successful</h2>
            <p>Your password has been updated successfully.</p>
          </div>
          <div>
            <button className="button-auth" onClick={() => navigate('/login')}>Go to Login</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-auth">
      <div className="box-auth">
        <div className="logo-wrapper">
          <img src={companyLogo} alt="Redwood Midcap" className="logo" />
        </div>

        <div className="auth-error-container">
          {error && (
            <div className="auth-error-message">{error}</div>
          )}
        </div>      
        
        <form onSubmit={handleSubmit}>
          <div className="form-header-auth">
            <h2>Create New Password</h2>
            <p>Enter your new password below</p>
          </div>

          <div className="form-group-auth">
            <label className="label-auth" for="password">New Password: </label>
            <input
              className="input-field-auth"
              placeholder="New Password"
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>
          <div className="form-group-auth">
            <label className="label-auth" for="confirmPassword">Confirm Password: </label>
          <input
            className="input-field-auth"
            placeholder="Confirm New Password"
            type="password"
            name="confirmPassword"
            value={form.confirmPassword}
            onChange={handleChange}
            disabled={isSubmitting}
          />
        </div>
        
        <button className="button-auth" type="submit" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              Resetting<span className="dots" />
            </>
          ) : (
            'Reset Password'
          )}
        </button>
      </form>
      
      <p className="signup-text">
        <Link to="/login">Back to Login</Link>
      </p>
      </div>
    </div>
  );
}

export default ResetPassword;